import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';

@Component({
  selector: 'app-delete-items-confirmation-modal',
  templateUrl: './delete-items-confirmation-modal.component.html',
  styleUrls: ['./delete-items-confirmation-modal.component.scss'],
})
export class DeleteItemsConfirmationModalComponent {
  @Output() dismissEvent: EventEmitter<void> = new EventEmitter();
  @Output() submitEvent: EventEmitter<void> = new EventEmitter();
  @Input() platform: PlatformEnum;
  @Input() totalSelected: Number;
  @Input() isTouch: boolean;
  @Input() additionalWarning: string;
  @Input() isWarning: boolean;
  @Input() singular: string;
  @Input() plural: string;
  @Input() hideCount?: boolean;

  readonly platformEnum = PlatformEnum;
  constructor() {}

  dismiss() {
    this.dismissEvent.emit();
  }

  submit() {
    this.submitEvent.emit();
  }
}
